import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f01bf52e")

_pushScopeId("data-v-f01bf52e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 施設登録 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, "施設名とその施設専用のワークスぺースを登録します。", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, "ワークスぺースには、その施設を識別するための英数字を入力してください。(abcclinicなど。最初の文字はアルファベットにしてください)", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, "次回ログイン時に自動でワークスぺースに移動します。", -1)
const _hoisted_5 = { class: "url-edit-frame" }
const _hoisted_6 = { class: "url-domain" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("施設登録")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_page_description = _resolveComponent("page-description")
  const _component_icon_edit_box = _resolveComponent("icon-edit-box")
  const _component_no_label_edit_box = _resolveComponent("no-label-edit-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")
  const _component_vue_content = _resolveComponent("vue-content")
  const _component_vue_frame = _resolveComponent("vue-frame")
  const _directive_focus = _resolveDirective("focus")
  const _directive_enter = _resolveDirective("enter")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_page_description, { class: "description" }, {
        default: _withId(() => [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content, null, {
        default: _withId(() => [
          _createVNode(_component_vue_content_item_frame, null, {
            default: _withId(() => [
              _withDirectives(_createVNode(_component_icon_edit_box, {
                class: "edit-box",
                icon: "clinic-medical",
                title: "施設名",
                placeholder: "施設の名称(例：○○治療院、△△医院)",
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
                validation: _ctx.isSubmit ? _ctx.nameError : undefined,
                ref: "nameRef"
              }, null, 8, ["modelValue", "validation"]), [
                [_directive_focus, 'nameRef'],
                [_directive_enter, {focus:'workSpaceRef'}]
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(`${_ctx.Domain}/w/`), 1),
                _withDirectives(_createVNode(_component_no_label_edit_box, {
                  class: "edit-box",
                  icon: "building",
                  title: "ワークスペース",
                  placeholder: "ワークスペース(英数字)",
                  modelValue: _ctx.workSpace,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.workSpace = $event)),
                  validation: _ctx.isSubmit ? _ctx.workSpaceError : undefined,
                  ref: "workSpaceRef"
                }, null, 8, ["modelValue", "validation"]), [
                  [_directive_enter, {click:'submitRef'}]
                ])
              ]),
              _createVNode(_component_normal_button, {
                class: "submit-button",
                state: "normal",
                disabled: _ctx.requesting,
                onClick: _ctx.onSubmit,
                ref: "submitRef"
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})